"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslationNs = void 0;
var react_i18next_1 = require("react-i18next");
/**
 * For not repating "PARTIAL.SUB."
 * @param {string} ns General namespace of translation
 * @param {string} partial Sub part of namespace
 * @returns {Function}
 */
var useTranslationNs = function (ns, partial) {
    var t = react_i18next_1.useTranslation(ns).t;
    return function (translationKey) {
        return t(partial + '.' + translationKey);
    };
};
exports.useTranslationNs = useTranslationNs;
